/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var UiFilterListIcon24Solid = forwardRef('UiFilterListIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M2.5 3a1.5 1.5 0 1 0 0 3h19a1.5 1.5 0 0 0 0-3h-19Z" }),
        React.createElement("path", { d: "M5 11.5A1.5 1.5 0 0 1 6.5 10h11a1.5 1.5 0 0 1 0 3h-11A1.5 1.5 0 0 1 5 11.5Z" }),
        React.createElement("path", { d: "M8 18.5A1.5 1.5 0 0 1 9.5 17h5a1.5 1.5 0 0 1 0 3h-5A1.5 1.5 0 0 1 8 18.5Z" })));
});
